import api from '@/services/api.service';

function unwrap<T>(res: unknown): T {
  const body = (res as { data?: unknown })?.data ?? res;
  return (body as { data?: T })?.data ?? (body as T);
}

export interface AssetGroupDto {
  id: string;
  company_id: string;
  code: string;
  name: string;
  description?: string | null;
  asset_cost_account_id?: string | null;
  inventory_clearing_account_id?: string | null;
  accumulated_depreciation_account_id?: string | null;
  depreciation_expense_account_id?: string | null;
  disposal_proceeds_account_id?: string | null;
  disposal_gain_account_id?: string | null;
  disposal_loss_account_id?: string | null;
  is_active?: boolean;
}

export interface ResolvedAssetGlDto {
  asset_cost_account_id: string | null;
  inventory_clearing_account_id: string | null;
  accumulated_depreciation_account_id: string | null;
  depreciation_expense_account_id: string | null;
  disposal_proceeds_account_id: string | null;
  disposal_gain_account_id: string | null;
  disposal_loss_account_id: string | null;
  source: string;
  asset_group_id: string | null;
  asset_group_code: string | null;
}

const assetGroupService = {
  async list(includeInactive = true): Promise<AssetGroupDto[]> {
    const res = await api.get('/assets/groups', {
      params: includeInactive ? { include_inactive: 'true' } : undefined,
    });
    const data = unwrap<AssetGroupDto[]>(res);
    return Array.isArray(data) ? data : [];
  },
  async create(body: Partial<AssetGroupDto>): Promise<AssetGroupDto> {
    const res = await api.post('/assets/groups', body);
    return unwrap(res);
  },
  async update(id: string, body: Partial<AssetGroupDto>): Promise<AssetGroupDto> {
    const res = await api.put(`/assets/groups/${id}`, body);
    return unwrap(res);
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/assets/groups/${id}`);
  },
};

export default assetGroupService;
